<template>
	<c-dialog ref="dialog" :title="title" width="1200" button-name="关闭" :cancel-button="false">
        <m-search ref="search" @search="searchHandle">
          <c-form ref="searchForm">
              <c-form-item type="select" label="管控类型" name="type" :options="type"></c-form-item>
              <c-form-item type="input" label="申请单号" name="apply_number"></c-form-item>
              <c-form-item type="select" label="审批状态" name="state" :options="state"></c-form-item>
              <c-form-item type="select" label="启用状态" name="enable_state" :options="enableState"></c-form-item>
              <c-form-item type="select" label="生效状态" name="effective_state" :options="effectiveState"></c-form-item>
              <c-form-item type="input" label="指定商品" name="product_info" placeholder="匹配商品名称、货号"></c-form-item>
              <c-form-item type="input" label="指定品牌" name="brand_info" placeholder="匹配品牌名称"></c-form-item>
              <c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
          </c-form>
        </m-search>
        <c-table ref="table" height="400">
        <c-table-column
                label="管控类型"
                name="type"
                width="80"
        >
            <template v-slot="{data}">
                <span v-if="data.type == 1" style="color:blue">按商品</span>
                <span v-if="data.type == 2" style="color:green">按品牌</span>
            </template>
        </c-table-column>

        <c-table-column
                label="申请单号"
                name="apply_number"
                width="140"
        ></c-table-column>

        <c-table-column
                label="审批状态"
                name="state"
                width="80"
        >
            <!--状态;0：草稿；1：待审核；2；审核通过；-1：审核驳回-->
            <template v-slot="{data}">
                <span v-if="data.state == 0" style="color:#999"> {{stateText[data.state]}}</span>
                <span v-if="data.state == 1" style="color:blue"> {{stateText[data.state]}}</span>
                <span v-if="data.state == 2" style="color:green"> {{stateText[data.state]}}</span>
                <span v-if="data.state == -1" style="color:red"> {{stateText[data.state]}}</span>
                <c-tooltip v-if="data.state == -1 && data.rejected_reason" :tip="data.rejected_reason" style="margin-left: 5px;"></c-tooltip>
            </template>
        </c-table-column>

        <c-table-column
                label="启用状态"
                name="enable_state"
                width="80"
        >
            <template v-slot="{data}">
                <span v-if="data.state == 2">
                   <span v-if="data.enable_state == 0" style="color:red">禁用</span>
                   <span v-if="data.enable_state == 1" style="color:green">启用</span>
                </span>
                <span v-else>--</span>
            </template>
        </c-table-column>

        <c-table-column
                label="生效状态"
                name="effective_state"
                width="80"
        >
            <template v-slot="{data}">
                <span v-if="data.effective_state == -1">--</span>
                <span v-else-if="data.effective_state == 0" style="color:gray">未生效</span>
                <span v-else-if="data.effective_state == 1" style="color:green">生效中</span>
                <span v-else-if="data.effective_state == 2" style="color:red">已过期</span>
                <span v-else-if="data.effective_state == 3" style="color:brown">已失效</span>
            </template>
        </c-table-column>

        <c-table-column
                label="生效时间 - 失效时间"
                width="300"
        >
            <template v-slot="{data}">
                <span>{{data.begin_time}} - {{data.end_time}}</span>
            </template>
        </c-table-column>

        <c-table-column
                label="会员手机号"
                name="user_manage_mobilephone"
                width="120"
        ></c-table-column>

        <c-table-column
                label="会员头像/昵称"
                name="head_photo"
                width="120"
        >
            <template v-slot="{data}">
                <div class="flex-center-cross">
                    <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                    <span>{{data.nick_name||'--'}}</span>
                </div>
            </template>
        </c-table-column>

        <c-table-column
                label="特殊价商品/品牌"
                width="200"
        >
            <template v-slot="{data}">
                <div class="flex-center-cross">
                    <c-image :src="data.product_img_url" preview size="30" style="margin-right: 10px;"></c-image>
                    <span>{{data.product_name||'--'}}</span>
                </div>
            </template>
        </c-table-column>

        <c-table-column
                label="减免方式"
                width="100"
        >
            <template v-slot="{data}">
                <span v-if="data.preferential_type == 1">特殊折扣</span>
                <span v-else-if="data.preferential_type == 2">直接减免</span>
            </template>
        </c-table-column>

        <c-table-column
                label="特殊价"
                width="100"
        >
            <template v-slot="{data}">
                <span v-if="data.preferential_type == 1">
                    打<span style="color:red">{{((data.discount||0)*10).toFixed(0)}}</span>折
                </span>
                <span v-else-if="data.preferential_type == 2">
                    减免<span style="color:red">￥{{data.reduced_money}}</span>元
                </span>
            </template>
        </c-table-column>

        <c-table-column
            label="申请时间"
            name="apply_date"
            width="150"
        ></c-table-column>
    </c-table>
	</c-dialog>
</template>

<script>
	export default {
        props: {
          multiple: Boolean
        },
        data(){
            return {
              title:'特殊价配置列表',
              serachParams:{},
              stateName: {
                0:'草稿',
                1:'待审核',
                2:'审核通过',
                '-1':'驳回'
              },
              state: [
                {name: '草稿', value: '0'},
                {name: '待审核', value: '1'},
                {name: '审核通过', value: '2'},
                {name: '驳回', value: '-1'}
              ],
              type: [
                {name: '按商品', value: '1'},
                {name: '按品牌', value: '2'}
              ],
              enableState: [
                {name: '禁用', value: '0'},
                {name: '启用', value: '1'}
              ],
              effectiveState: [
                {name: '--',value: '-1'},
                {name: '未生效',value: '0'},
                {name: '生效中',value: '1'},
                {name: '已过期',value: '2'},
                {name: '已失效',value: '3'}
              ]
            }
        },
        computed: {

            stateText() {
                var state = {};
                this.state.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },
        methods: {
            searchHandle(data) {
              data = Object.assign({}, data, this.serachParams);
              this.$refs.table.load({
                url: '/special_price/detail/list',
                data
              });
            },

            open(params) {
              this.serachParams = params;
              if (params && params.title){
                  this.title = params.title;
              }
              this.$refs.searchForm.clear();
              this.$refs.search.search();
              this.$refs.dialog.open();
            }
        }
	}
</script>